// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advanced-pcb-form {
    width: 80%;
    margin: auto auto 2em auto;
    padding: 1.25rem;
    background: #ffffff;
    border-radius: 0.625em;
    box-shadow: 0em 0.25em 0.625m rgba(0,0,0,0.1);
    font-family: 'Arial', sans-serif;
}
.layer-options {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
}
.layer-buttons {
    display: grid;
    grid-template-columns: repeat(8, minmax(6em, 1fr));
    gap: 0.5em;
    width: 5em;

}
.pcb-tabs {
    display: flex;
    gap: 0.5em;
    justify-content: center;
    margin-top: 0.625em;
}
.more-options {
    display: flex;
    width: min-content;
    justify-content: flex-end;
    margin-top: 0.625em;
}
.more-options-button {
    background-color: #ddd !important;
    color: black;
    font-family: 'Fivo Sans Regular';
    width: max-content;
}
.surface-container {
    display: flex;
    flex-direction: column;
    gap: 0.3125em;
}
.color-options, .more-surface,.surface-buttons, .thickness-buttons{
    display: grid; 
    grid-template-columns: repeat(auto-fit, minmax(6em, 1fr));
    gap: 0.5em;
    width: 100%;
}
.info-tooltip {
    position: relative;
    display: inline-block;
    cursor: pointer;
    margin-left: 0.5em;
}
.tooltip-icon {
    font-size: 1em;
    color: #b51f25;
    cursor: pointer;
    border-radius: 50%;
    padding:0.125em;
    transition: color 0.3s ease-in-out;
}
.tooltip-icon:hover {
    color: #b51f24cc;
}
.tooltip-text {
    visibility: hidden;
    width: 11.25em;
    background-color: #222;
    color: #fff;
    text-align: center;
    border-radius: 0.25em;
    padding:0.5em;
    position: absolute;
    z-index: 10;
    bottom: 125%; /* Position above the icon */
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
    font-size: 0.75em;
    white-space: normal;
    line-height: 1.3;
}
.info-tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
.color-square {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.25em;
    height: 1.25em;
    border-radius: 0.25em;
    margin-right: 0.5em;
    position: relative;
}
.x-mark{
    font-size: 0.75em;
    color: #ccc;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
h2, h3 {
    text-align: center;
    font-family: 'Fivo Sans Bold';
    color: #333;
}

.pcb-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

.pcb-table td {
    padding: 10px;
    align-items: left;
    text-align: left;
    font-family: "Fivo Sans Regular";
}

.pcb-button {
    padding: 8px 16px;
    margin: 5px;
    border: none;
    color:#333;
    background-color: #ffffff;
    cursor: pointer;
    transition: 0.3s;
    border-radius: 5px;
    border: 1px solid #fff;
    font-family: "Fivo Sans Regular";
}

.pcb-button:not(.selected):hover {
    background-color: #f8f9fa !important;
    border: 1px solid #b51f25 !important;
    color: #333;
    font-family: "Fivo Sans Medium";
}

.selected {
    background-color: #b51f25;
    color: white !important;
    font-family: "Fivo Sans Medium";
}
.color-options {
    display: grid; 
    grid-template-columns: repeat(5, minmax(6em, 1fr));
    gap: 0.5em;
    justify-content:left;
    align-content:left;
}
.color-option {
    display: block;
    align-items: left;
    gap: 0.5em;
}
.color-square {
    width: 1em;
    height: 1em;
    border-radius: 0.25em;
    display: inline-block;
}

.input-pcb {
    width: 5em;
    padding: 0.3125em;
    margin: 0.3125em;
    border: 0.0625em solid #ccc;
    border-radius: 0.3125em;
}

.expand-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    border-top: 1px solid #ddd;
    padding-top: 10px;
}
.expand-section label {
    margin-left: 0.625em;
    font-size: 1em;
    font-family: "Fivo Sans Regular";
    color: "#333";
}

.expand-button {
    background-color: #ffffff !important;
    color: #333;
    font-family: 'Fivo Sans Regular';
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 5px;
    transition: background-color 0.3s;
}

.expand-button:hover {
    background-color: #e0e0e0;
}

.advanced-options {
    margin-top: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 5px;
}

.submit-button {
    display: block;
    width: 100%;
    background-color: #228b22 !important;
    color: white;
    padding: 10px;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 20px;
    transition: background-color 0.3s;
}
.remark {
    background-color: #f9f9f9 !important;
    font-family: 'Fivo Sans Regular';
    color: #333;
    font-size: 0.9rem;
    margin-top: 0.833em;
    margin-left: -1em
}
.remark-input {
    width: 100%;
    padding: 5px;
    margin: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
}
.remark:hover {
    background-color: #f9f9f9 !important;
    color: #b51f25;
}

/* Responsive table: Switch columns to rows on small screens */
/* Responsive table: Switch columns to rows on small screens */
@media screen and (max-width: 768px) {
    .pcb-table {
        width: 100%;
        border-collapse: collapse;
        justify-content: center;
    }
    .advanced-options {
        width: auto;
        padding: 0.9375em;

    }
   .pcb-table td {
        display: block;
        padding: 0.625em;
        justify-content: flex-start;
        gap:0.5em;
        text-align: left;
        width: auto;
    }
    .pcb-button {
        width: auto;
        padding: 0.5em;
        text-align: center;
        font-size: 0.875em;
        box-sizing: border-box;
    }
    .color-options {
        display: grid; 
        grid-template-columns: repeat(3, minmax(6em, 1fr));
        gap: 0.5em;
        justify-content:left;
        align-content:left;
    }
    .more-surface {
        display: grid;
        grid-template-columns: repeat(3,minmax(6em, 1fr));
        gap: 0.5em;
        margin-top: 0.5em;
    }
    /* .thickness-buttons {
        display: grid;
        grid-template-columns: repeat(3,minmax(6em, 1fr));
        gap: 0.5em;
        width: 100%;
    } */
    .layer-buttons {
        display: grid;
        grid-template-columns: repeat(4,minmax(6em, 1fr));
        gap: 0.5em;
        width: 100%;
    }
    .surface-buttons {
        display: grid;
        grid-template-columns: repeat(3,minmax(6em, 1fr));
        gap: 0.5em;
        width: 100%;
    }
    .more-options {
        display: flex;
        width: 100%;
        justify-content: left;
        margin-top: 0.625em;
    }

}

/* Ensure table displays properly on medium-sized screens */
@media screen and (max-width: 1024px) {
    .pcb-table {
        width: 100%;
    }
    .pcb-table td {
        font-size: 14px;
    }
    .submit-button {
        font-size: 14px;
        padding: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PCBSelection/AdvancedPCBForm.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,6CAA6C;IAC7C,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,aAAa;IACb,kDAAkD;IAClD,UAAU;IACV,UAAU;;AAEd;AACA;IACI,aAAa;IACb,UAAU;IACV,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,iCAAiC;IACjC,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,aAAa;IACb,yDAAyD;IACzD,UAAU;IACV,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kCAAkC;AACtC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY,EAAE,4BAA4B;IAC1C,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,iEAAiE;IACjE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,kDAAkD;IAClD,UAAU;IACV,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,cAAc;IACd,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;AACA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA,8DAA8D;AAC9D,8DAA8D;AAC9D;IACI;QACI,WAAW;QACX,yBAAyB;QACzB,uBAAuB;IAC3B;IACA;QACI,WAAW;QACX,iBAAiB;;IAErB;GACD;QACK,cAAc;QACd,gBAAgB;QAChB,2BAA2B;QAC3B,SAAS;QACT,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,kDAAkD;QAClD,UAAU;QACV,oBAAoB;QACpB,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,iDAAiD;QACjD,UAAU;QACV,iBAAiB;IACrB;IACA;;;;;OAKG;IACH;QACI,aAAa;QACb,iDAAiD;QACjD,UAAU;QACV,WAAW;IACf;IACA;QACI,aAAa;QACb,iDAAiD;QACjD,UAAU;QACV,WAAW;IACf;IACA;QACI,aAAa;QACb,WAAW;QACX,qBAAqB;QACrB,mBAAmB;IACvB;;AAEJ;;AAEA,2DAA2D;AAC3D;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,aAAa;IACjB;AACJ","sourcesContent":[".advanced-pcb-form {\n    width: 80%;\n    margin: auto auto 2em auto;\n    padding: 1.25rem;\n    background: #ffffff;\n    border-radius: 0.625em;\n    box-shadow: 0em 0.25em 0.625m rgba(0,0,0,0.1);\n    font-family: 'Arial', sans-serif;\n}\n.layer-options {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5em;\n}\n.layer-buttons {\n    display: grid;\n    grid-template-columns: repeat(8, minmax(6em, 1fr));\n    gap: 0.5em;\n    width: 5em;\n\n}\n.pcb-tabs {\n    display: flex;\n    gap: 0.5em;\n    justify-content: center;\n    margin-top: 0.625em;\n}\n.more-options {\n    display: flex;\n    width: min-content;\n    justify-content: flex-end;\n    margin-top: 0.625em;\n}\n.more-options-button {\n    background-color: #ddd !important;\n    color: black;\n    font-family: 'Fivo Sans Regular';\n    width: max-content;\n}\n.surface-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.3125em;\n}\n.color-options, .more-surface,.surface-buttons, .thickness-buttons{\n    display: grid; \n    grid-template-columns: repeat(auto-fit, minmax(6em, 1fr));\n    gap: 0.5em;\n    width: 100%;\n}\n.info-tooltip {\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n    margin-left: 0.5em;\n}\n.tooltip-icon {\n    font-size: 1em;\n    color: #b51f25;\n    cursor: pointer;\n    border-radius: 50%;\n    padding:0.125em;\n    transition: color 0.3s ease-in-out;\n}\n.tooltip-icon:hover {\n    color: #b51f24cc;\n}\n.tooltip-text {\n    visibility: hidden;\n    width: 11.25em;\n    background-color: #222;\n    color: #fff;\n    text-align: center;\n    border-radius: 0.25em;\n    padding:0.5em;\n    position: absolute;\n    z-index: 10;\n    bottom: 125%; /* Position above the icon */\n    left: 50%;\n    transform: translateX(-50%);\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\n    font-size: 0.75em;\n    white-space: normal;\n    line-height: 1.3;\n}\n.info-tooltip:hover .tooltip-text {\n    visibility: visible;\n    opacity: 1;\n}\n.color-square {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 1.25em;\n    height: 1.25em;\n    border-radius: 0.25em;\n    margin-right: 0.5em;\n    position: relative;\n}\n.x-mark{\n    font-size: 0.75em;\n    color: #ccc;\n    font-weight: bold;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\nh2, h3 {\n    text-align: center;\n    font-family: 'Fivo Sans Bold';\n    color: #333;\n}\n\n.pcb-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 10px;\n}\n\n.pcb-table td {\n    padding: 10px;\n    align-items: left;\n    text-align: left;\n    font-family: \"Fivo Sans Regular\";\n}\n\n.pcb-button {\n    padding: 8px 16px;\n    margin: 5px;\n    border: none;\n    color:#333;\n    background-color: #ffffff;\n    cursor: pointer;\n    transition: 0.3s;\n    border-radius: 5px;\n    border: 1px solid #fff;\n    font-family: \"Fivo Sans Regular\";\n}\n\n.pcb-button:not(.selected):hover {\n    background-color: #f8f9fa !important;\n    border: 1px solid #b51f25 !important;\n    color: #333;\n    font-family: \"Fivo Sans Medium\";\n}\n\n.selected {\n    background-color: #b51f25;\n    color: white !important;\n    font-family: \"Fivo Sans Medium\";\n}\n.color-options {\n    display: grid; \n    grid-template-columns: repeat(5, minmax(6em, 1fr));\n    gap: 0.5em;\n    justify-content:left;\n    align-content:left;\n}\n.color-option {\n    display: block;\n    align-items: left;\n    gap: 0.5em;\n}\n.color-square {\n    width: 1em;\n    height: 1em;\n    border-radius: 0.25em;\n    display: inline-block;\n}\n\n.input-pcb {\n    width: 5em;\n    padding: 0.3125em;\n    margin: 0.3125em;\n    border: 0.0625em solid #ccc;\n    border-radius: 0.3125em;\n}\n\n.expand-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 20px;\n    border-top: 1px solid #ddd;\n    padding-top: 10px;\n}\n.expand-section label {\n    margin-left: 0.625em;\n    font-size: 1em;\n    font-family: \"Fivo Sans Regular\";\n    color: \"#333\";\n}\n\n.expand-button {\n    background-color: #ffffff !important;\n    color: #333;\n    font-family: 'Fivo Sans Regular';\n    padding: 5px 10px;\n    cursor: pointer;\n    border-radius: 5px;\n    transition: background-color 0.3s;\n}\n\n.expand-button:hover {\n    background-color: #e0e0e0;\n}\n\n.advanced-options {\n    margin-top: 20px;\n    padding: 15px;\n    background: #f8f9fa;\n    border-radius: 5px;\n}\n\n.submit-button {\n    display: block;\n    width: 100%;\n    background-color: #228b22 !important;\n    color: white;\n    padding: 10px;\n    border: none;\n    border-radius: 5px;\n    font-size: 16px;\n    cursor: pointer;\n    margin-top: 20px;\n    transition: background-color 0.3s;\n}\n.remark {\n    background-color: #f9f9f9 !important;\n    font-family: 'Fivo Sans Regular';\n    color: #333;\n    font-size: 0.9rem;\n    margin-top: 0.833em;\n    margin-left: -1em\n}\n.remark-input {\n    width: 100%;\n    padding: 5px;\n    margin: 5px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n.remark:hover {\n    background-color: #f9f9f9 !important;\n    color: #b51f25;\n}\n\n/* Responsive table: Switch columns to rows on small screens */\n/* Responsive table: Switch columns to rows on small screens */\n@media screen and (max-width: 768px) {\n    .pcb-table {\n        width: 100%;\n        border-collapse: collapse;\n        justify-content: center;\n    }\n    .advanced-options {\n        width: auto;\n        padding: 0.9375em;\n\n    }\n   .pcb-table td {\n        display: block;\n        padding: 0.625em;\n        justify-content: flex-start;\n        gap:0.5em;\n        text-align: left;\n        width: auto;\n    }\n    .pcb-button {\n        width: auto;\n        padding: 0.5em;\n        text-align: center;\n        font-size: 0.875em;\n        box-sizing: border-box;\n    }\n    .color-options {\n        display: grid; \n        grid-template-columns: repeat(3, minmax(6em, 1fr));\n        gap: 0.5em;\n        justify-content:left;\n        align-content:left;\n    }\n    .more-surface {\n        display: grid;\n        grid-template-columns: repeat(3,minmax(6em, 1fr));\n        gap: 0.5em;\n        margin-top: 0.5em;\n    }\n    /* .thickness-buttons {\n        display: grid;\n        grid-template-columns: repeat(3,minmax(6em, 1fr));\n        gap: 0.5em;\n        width: 100%;\n    } */\n    .layer-buttons {\n        display: grid;\n        grid-template-columns: repeat(4,minmax(6em, 1fr));\n        gap: 0.5em;\n        width: 100%;\n    }\n    .surface-buttons {\n        display: grid;\n        grid-template-columns: repeat(3,minmax(6em, 1fr));\n        gap: 0.5em;\n        width: 100%;\n    }\n    .more-options {\n        display: flex;\n        width: 100%;\n        justify-content: left;\n        margin-top: 0.625em;\n    }\n\n}\n\n/* Ensure table displays properly on medium-sized screens */\n@media screen and (max-width: 1024px) {\n    .pcb-table {\n        width: 100%;\n    }\n    .pcb-table td {\n        font-size: 14px;\n    }\n    .submit-button {\n        font-size: 14px;\n        padding: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
